import axios from "axios";
import { refreshAccessTokenOnce } from "./config";

/*
 * Talks to the Work API (where discussions live) with the Accounts token.
 * Unlike config.js it never logs the user out: a 401 here usually means the
 * person has no Works account, which must not end their Accounts session.
 */
export const workApi = axios.create({
  baseURL: process.env.REACT_APP_WORK_API_PATH,
  timeout: 15000,
});

workApi.interceptors.request.use((config) => {
  config.headers = {
    ...config.headers,
    Authorization: "Bearer " + localStorage.getItem("accessToken"),
  };
  return config;
});

workApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;

    if (status === 401 && original && !original._retry) {
      original._retry = true;
      try {
        const token = await refreshAccessTokenOnce();
        original.headers = { ...original.headers, Authorization: `Bearer ${token}` };
        return workApi(original);
      } catch {
        // fall through: report the 401, keep the Accounts session
      }
    }

    return Promise.reject({
      ...(error.response?.data ?? {}),
      status,
      noWorksAccount: status === 401,
      message:
        status === 401
          ? "You don't have a Works portal account yet, so you can't use discussions. Ask an admin to add you."
          : error.response?.data?.message ?? error.message ?? "Something went wrong",
    });
  }
);
